import React from 'react';
import { ProtocoloPage } from './pages/ProtocoloPage';
export function App() {
  return <ProtocoloPage data-id="element-0" />;
}